<div [class]="classes" class="countdown">
  <div class="countdown-header d-flex justify-content-center align-items-center">
    <img
      *ngIf="config.icon.url"
      [height]="config.icon.height"
      [ngSrc]="config.icon.url"
      [style.height.px]="config.icon.height"
      [style.width.px]="config.icon.width"
      [width]="config.icon.width"
      alt="icon"
      class="ml-1 mr-1"
    />
    <span class="countdown-label mr-1">{{ label | translate }}</span>
    <app-counter-widget
      (breakpointOutEvent)="breakpointOutEvent.emit($event)"
      (tickEvent)="onTick($event)"
      (timeOutEvent)="timeOutEvent.emit($event)"
      [initialState]="initialState"
      [type]="counterType"
    >
    </app-counter-widget>
  </div>
  <div *ngIf="showProgressBar" class="countdown-progress mt-2">
    <div [style.width]="progressValue" class="countdown-progress-line"></div>
  </div>
</div>
